<template>
  <div v-if="usageData">
    <div class="usage-item-wrapper">
      <VsLoader :visible="!!usageData.isLoading" />
      <div
        v-if="!usageData.isLoading"
        class="usage-item"
        :class="{
          active: isActiveUsage,
          disabled: usageData.disabled || showSorryMessage,
          enable: !usageData.disabled && !usageData.isError,
        }"
        @click="changeUsage"
      >
        <template v-if="showSorryMessage">
          <div class="sorry-string">
            <p>{{ "charts.errorMessage.sorryMessage1" | t }}</p>
            <p>{{ "charts.errorMessage.sorryMessage2" | t }}</p>
          </div>
        </template>
        <template v-else>
          <ChartSelectorItemPanel
            :title="$t(usageItem.rateTitle)"
            :value="usageData.rateTotal | numberFormat('0.0%')"
            :disabled="usageData.disabled"
            :isError="usageData.isError"
            @reload="$emit('reload')"
          >
            <template v-if="usageItem.tooltip" v-slot:tooltip>
              <VsTooltip :label="usageItem.tooltip" />
            </template>
          </ChartSelectorItemPanel>
          <hr class="devider" />
          <ChartSelectorItemPanel
            :title="$t(usageItem.valueTitle)"
            :value="formatedValue"
            :disabled="usageData.disabled"
            :isError="usageData.isError"
            @reload="$emit('reload')"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ChartSelectorItemPanel from "./ChartSelectorItemPanel";
import { VS_SALES } from "@/misc/desktopCharts";
import { mapGetters } from "vuex";
const ACNE_STORE_ID = 54;

export default {
  components: {
    ChartSelectorItemPanel,
  },
  props: {
    usageItem: {
      type: Object,
      required: true,
    },
    isActiveUsage: {
      type: Boolean,
      required: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    usageData: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      currentStore: "user/getCurrentStore",
    }),
    formatedValue() {
      const filters = this.$options.filters;
      return this.usageItem.currency
        ? filters.currencyFormat(this.usageData.valueTotal)
        : filters.numberFormat(this.usageData.valueTotal, "0,0");
    },
    showSorryMessage() {
      return this.currentStore.store_id === ACNE_STORE_ID && this.usageItem.valueChartName === VS_SALES;
    },
  },
  methods: {
    changeUsage() {
      if (this.usageItem.disabled || this.usageData.isError || this.showSorryMessage) {
        return;
      }
      this.$emit("changeUsage", this.usageItem.name);
    },
  },
};
</script>

<style scoped lang="scss">
.usage-item-wrapper {
  position: relative;
  height: 180px;
}

.usage-item {
  height: 177px;
  padding: 15px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  color: #3a3a3a;
  background-color: white;
}

.enable {
  cursor: pointer;
}

.disabled {
  cursor: not-allowed;
}

.active {
  color: white;
  background-color: $primary;

  &::after {
    position: absolute;
    top: 96%;
    left: 49%;
    width: 8px;
    height: 8px;
    border-right: 1px solid rgba(0, 0, 0, 0.2);
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    background-color: $primary;
    transform: rotate(45deg);
    content: "";
  }
}

.devider {
  height: 1px;
  margin: 0;
  background: rgba(0, 0, 0, 0.2);
}

.sorry-string {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  margin: 0;
  font-size: 12px;
  text-align: center;
  transform: translateY(-50%);
}
</style>
